module.exports = __webpack_public_path__ + "img/financial.56cdc963.png";